<template>
    <h4 class="date">{{currentDate}}</h4>
</template>
<script>
export default {
    name: 'Date',
    mounted: function() {
        this.time();
        this.timeCounter();
    },
    updated: function() {
        this.$emit('currentDate', this.currentDate2)
    },
    methods: {
        timeCounter: function(){
            
            this.intervalid1 = setInterval(function(){
            this.time()
            }.bind(this), 1000);
        },
        time: function(){
            const newDate = new Date();
            const day = newDate.toLocaleDateString('PL', {
                weekday: 'long',
            });
            const date = newDate.toLocaleDateString('PL', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            });
            const time = newDate.toLocaleTimeString('PL', {
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            });
            this.currentDate =  `${day.charAt(0).toUpperCase() + day.substring(1)} ${date} ${time}`;
            
            // currentDate2 jest przesyłana do komponentu MainApp i wstawiana jako data do logów w przypadku wysyłki tylko email
            this.currentDate2 = newDate.getFullYear() + "-" + ("0" + (newDate.getMonth() + 1)).slice(-2) + "-" + ("0" + newDate.getDate()).slice(-2) + ' ' + time;

        }
    },
    data: function() {
        return {
            currentDate: '',
            currnetDate2: '',
        }
    }
}
</script>

<style lang="scss" scoped>
    .date {
        color: green;
        font-family: 'Source Code Pro', monospace;
        font-size: 15px;
    }
</style>